import React from 'react';
import classNames from 'classnames';

/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 */
function renderAmp() {
  const {
    ampId,
    body,
    context: {
      cssPrefix,
    },
    extraClassNames,
    header,
    loadStyles,
    overlayExtraClassNames,
  } = this.props; // eslint-disable-line

  return (
    <div className={classNames({
      [`${cssPrefix}__modal`]: loadStyles,
      ...extraClassNames,
      ...overlayExtraClassNames,
    })}
    >
      <amp-lightbox id={ampId} layout="nodisplay">
        <div className={`${cssPrefix}__modal--overlay`} on={`tap:${ampId}.close`} role="button" tabIndex="0" />
        <div className={`${cssPrefix}__modal--content`}>
          <span className={`${cssPrefix}__modal--close`} on={`tap:${ampId}.close`} role="button" tabIndex="0" />
          <div className={`${cssPrefix}__modal--heading modal_heading`}>{header}</div>
          <div className={`${cssPrefix}__modal--body modal_body`}>
            {body}
          </div>
        </div>
      </amp-lightbox>
    </div>
  );
}

export default renderAmp;
